import { z } from 'zod';

export enum SortOptions {
  alphabetical = 'alphabetical',
  featured = 'featured',
  price = 'price',
  priceDesc = 'priceDesc',
  rating = 'rating',
  recommended = 'recommended',
  thcAsc = 'thcAsc',
  thcDesc = 'thcDesc',
}

export const SortOptionsSchema = z.enum(SortOptions);

export const SORT_OPTIONS = Object.freeze([
  { label: 'Recommended', value: SortOptions.recommended },
  { label: 'Featured', value: SortOptions.featured },
  { label: 'A - Z', value: SortOptions.alphabetical },
  { label: 'Rating', value: SortOptions.rating },
  { label: 'Lowest price', value: SortOptions.price },
  { label: 'Highest price', value: SortOptions.priceDesc },
  { label: 'Lowest THC %', value: SortOptions.thcAsc },
  { label: 'Highest THC %', value: SortOptions.thcDesc },
]);
